<template>
  <div class="pfooter">
    <div class="content" v-for="(item,i) in list" :key="i">
      <div class="sm-title-16 content-title">{{ item.title }}</div>
      <div class="content-item"
           v-for="(hItem,hIndex) in item.hrefList"
           :key="hIndex"
           @click="goPage(hItem)">
        <div class="content-text">{{ hItem.text }}</div>
        <img class="content-arrow" :src="`${$g.imgPrefix}/img/footer/arrow-right@2x.webp`">
      </div>
    </div>
    <div class="content mb-4">
      <!-- 语言-->
      <div class="sm-title-16 content-title">{{$t('footer.language')}}</div>
      <div class="lang">
        <img :src="`${$g.imgPrefix}/img/footer/arrow-down@2x.webp`">
        <el-select
            @change="handleChange"
            v-model="language"
            placeholder="">
          <el-option v-for="(item,index) in $g.languageList"
                     :key="index"
                     :label=item.name
                     :value=item.code>
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="link">
      <img :src="`${$g.imgPrefix}/img/footer/image140@2x.webp`">
      <img :src="`${$g.imgPrefix}/img/footer/Vector@2x.webp`">
      <img :src="`${$g.imgPrefix}/img/footer/Vector@2x (1).webp`">
      <img :src="`${$g.imgPrefix}/img/footer/visa.webp`">
      <img style="width:63px;" :src="`${$g.imgPrefix}/img/footer/discover.webp`">
    </div>
    <div class="bottom">
      <div>Copyright &copy; 2024 Guangxi Nanning Yuanchuang Trading Co., Ltd.and ZHONGLING TRADE LIMITED</div>
      <div>E-mail consultation: delecia@alongshare.com</div>
      <!-- 所有版权、商标、服务标记均属于相应所有者。-->
<!--      <div class="mb-2">{{$t('footer.footer_10')}}</div>-->
<!--      &lt;!&ndash; 版权所有 © 2024 GAMESGO LIMITED 保留所有权利（Unit 1804 South Bank Tower, 55 Upper Ground, London, SE1 9EY）附带条约 和隐私政策&ndash;&gt;-->
<!--      <div>{{$t('footer.footer_11')}}{{$t('footer.footer_12')}}</div>-->
    </div>
  </div>
</template>

<script>
import {
  isEmpty,
} from '@/util/util'
import PubSub from "pubsub-js";
export default {
  name: "footerTemp",
  data() {
    return {
      language: '',
      setLangID:null,
      hrefList:[],
      list: [
        {
          //站点地图
          title: this.$t('footer.map'),
          hrefList: [
            {
              //主屏幕
              href: 'phonehome',
              text: this.$t('footer.homescreen')
            },
            {
              //联盟计划
              href: 'pfriends',
              text: this.$t('map.affiliateprogram')
            },
            {
              //订阅
              href: 'psubscribe',
              text: this.$t('map.subscribe')
            },
            {
              //客户服务中心
              href: 'paftersales',
              text: this.$t('footer.aftersales')
            }
          ]
        },
        {
          //帮助中心
          title: this.$t('map.helpcenter'),
          hrefList: [
            {
              //使用条款
              params: {
                id: 9
              },

              href: 'phelpdetail',
              text: this.$t('footer.termsofuse')
            },
            {
              //退款政策
              params: {
                id: 10
              },
              href: 'phelpdetail',
              text: this.$t('footer.refundpolicy')
            },
            {
              //隐私政策
              params: {
                id: 11
              },
              href: 'phelpdetail',
              text: this.$t('footer.privacypolicy')
            }
          ]
        }
      ]
    }
  },
  methods: {
    goPage(item) {
      if (!isEmpty(item.params)) {
        this.$router.push({
          name: item.href,
          query: item.params
        })
        return;
      }


      if(['psubscribe','paftersales','pfriends','phonehome'].includes(item.href)){
        //订阅
        if(item.href==='psubscribe'){
          PubSub.publish('setTabActive', 'psubscribe');
        }else if(item.href==='paftersales'){
          //客户服务中心 就是售后支持
          PubSub.publish('setTabActive', 'paftersales');
        }else if(item.href==='pfriends'){
          //联盟计划
          PubSub.publish('setTabActive', 'pfriends');
        } else if(item.href==='phonehome'){
          //主屏幕
          PubSub.publish('setTabActive', 'phonehome');
        }
        this.$emit('scrollTop', 'playout');
        return;
      }

      this.$router.push({
        name: item.href
      })
    },
    handleChange(value) {
      this.$emit('handleChange', value)
    },
  },
  mounted() {
    this.language = localStorage.lang;
    this.setLangID = PubSub.subscribe('changeLanguage', (message, activeName) => {
      this.language = activeName;
    });
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/footer.scss";
</style>